import React, { useEffect, useState } from 'react';
import { OutcomeInfo, OutcomeOptions } from '../../../models/APIModels';
import useScreenWidth from '../../../hooks/useScreenWidth';
import { Grid, Box, Chip, Avatar, IconButton } from '@mui/material';
import clientUtils from '../../../Utils/clientUtils';
import InputConfiguration from '../ModelInputSection/InputConfiguration';
import { cloneDeep } from 'lodash';
import AddIcon from '@mui/icons-material/Add';
import OutcomeConfiguration from './OutcomeConfiguration';
import OutcomeOptionConfiguration from './OutcomeOptionConfiguration';
import { useFormContext } from 'react-hook-form';
import { multilineEnabler } from '../../../Utils/displaySettingsUtils';
import { InterfaceTypes } from '../../../enums';
import CancelIcon from '@mui/icons-material/Cancel';

interface IProps {
  formValues: any;
  dataTypes: any[];
}
const DefineModelOutcomes = ({ formValues, dataTypes }: IProps) => {
  const widthSize = useScreenWidth();
  const [outcomes, setOutComes] = useState<OutcomeInfo[]>([]);
  const [selectedOutcome, setSelectedOutcome] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState();

  const {
    register,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const watchInterfaceType = watch('interfaceType', 'Form');
  // ⛏️ Function/Method :: Configure variableDisplayOptions
  const setVal = (name: string, data: any) => {
    formValues.setValue(name, data);
  };
  const configureVariableDisplayOptions = (mode: string, inputDetails: any, setFor?: string) =>
    multilineEnabler(mode, 'outputcon', inputDetails?.name, formValues.getValues('variableDisplayOptions'), setVal,setFor);

  const handleOutcomeClick = (outcome) => {
    setSelectedOutcome(outcome);
    setSelectedOption();
  };
  const addNewOutcome = () => {
    const newOutcome = {
      name: 'New Outcome',
      outcomeDescription: '',
      outcomeType: 'String',
      options: [],
    };
    let newOutcomes = cloneDeep(outcomes);
    setSelectedOutcome(newOutcome);
    newOutcomes.push(newOutcome);
    setOutComes(newOutcomes);
  };

  const updateOutcomeConfiguration = (outcomes: OutcomeInfo[], selectedOutcome: OutcomeInfo) => {
    setOutComes(outcomes);
    setSelectedOutcome(selectedOutcome);
    setValue('aiEngineConfig.outcomes', outcomes);
  };

  const handleOptionClick = (option) => {
    // console.log(option);
    setSelectedOption(option);
  };

  const addNewOption = () => {
    const newOption = {
      optionFriendlyName: 'New Option',
      optionValue: '',
    };
    if (selectedOutcome) {
      const toUpdateOutcome = cloneDeep(selectedOutcome);
      let options = cloneDeep(selectedOutcome.options);
      options.push(newOption);
      toUpdateOutcome.options = options;
      setSelectedOutcome(toUpdateOutcome);
      setSelectedOption(newOption);
      setSelectedOptions(options);
    }
  };
  const updateOptionConfiguration = (selectedOutcome: OutcomeInfo, selectedOption: OutcomeOptions) => {
    // setInputs(inputs);
    setSelectedOutcome(selectedOutcome);
    setSelectedOption(selectedOption);
    const cloneOutcomes = cloneDeep(outcomes);
    const index = cloneOutcomes.findIndex((i) => i.name === selectedOutcome.name);
    if (index !== -1) {
      cloneOutcomes[index] = selectedOutcome;
      setOutComes(cloneOutcomes);
      setValue('aiEngineConfig.outcomes', cloneOutcomes);
    }
  };

  const handleDeleteOutcome = (e, outcome) => {
    e.preventDefault();
    const cloneOutcomes = cloneDeep(outcomes);
    const newOutcomes = cloneOutcomes.filter((o) => o.name !== outcome.name);
    setOutComes(newOutcomes);
    setValue('aiEngineConfig.outcomes', newOutcomes);
    configureVariableDisplayOptions('pop', outcome);
  };

  const handleDeleteOption = (e, option) => {
    const toUpdateInput = cloneDeep(selectedOutcome);
    let options = cloneDeep(selectedOutcome.options);
    options = options.filter((o) => o.optionFriendlyName !== option.optionFriendlyName);
    toUpdateInput.options = options;
    setSelectedOutcome(toUpdateInput);
    setSelectedOption('');
    setSelectedOptions(options);
  };

  useEffect(() => {
    let newInputs = formValues.getValues('aiEngineConfig.outcomes') ? formValues.getValues('aiEngineConfig.outcomes') : [];
    setOutComes(newInputs);
    return () => {
      console.log('cleaned up');
    };
  }, []);

  useEffect(() => {}, [outcomes]);

  useEffect(() => {
    if (selectedOutcome) {
      setSelectedOptions(selectedOutcome.options);
    }
  }, [selectedOutcome]);

  return (
    <Grid container direction="row" justifyContent="space-evenly" spacing={3} sx={{ marginLeft: '0px' }}>
      <Grid item xs={12} sm={12} md={4} style={clientUtils.getGridStyle('left', widthSize)}>
        <Grid container spacing={2} direction="row">
          <Grid item xs={12}>
            <Box className="hedading">
              <div className="title">List of Outcomes</div>
              <div className="line"></div>
            </Box>
          </Grid>
          {outcomes.length > 0 &&
            outcomes.map((outcome, index) => {
              return (
                <Grid item xs={6} sm={4} md={6} lg={4} key={outcomes.indexOf(outcome)}>
                  <Chip
                    label={outcome.name}
                    variant={selectedOutcome && outcome.name === selectedOutcome.name ? 'filled' : 'outlined'}
                    color="success"
                    size="small"
                    avatar={<Avatar color="success">{outcome.name.charAt(0)}</Avatar>}
                    clickable
                    onClick={(e) => handleOutcomeClick(outcome)}
                    onDelete={(e) => handleDeleteOutcome(e, outcome)}
                    title={outcome.name}
                    deleteIcon={
                      <IconButton disabled={watchInterfaceType === InterfaceTypes.Chatbot}>
                        {watchInterfaceType === InterfaceTypes.Form && <CancelIcon fontSize="small" />}
                      </IconButton>
                    }
                  />
                </Grid>
              );
            })}
          <Grid item xs={6} sm={4} md={6} lg={4}>
            {watchInterfaceType === InterfaceTypes.Form && (
              <Chip
                label="Add New Outcome"
                // variant="outlined"
                color="primary"
                size="small"
                clickable
                icon={<AddIcon />}
                onClick={(e) => addNewOutcome()}
                title="Add New Outcome"
                disabled={watchInterfaceType === InterfaceTypes.Chatbot}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={4} style={clientUtils.getGridStyle('right', widthSize)}>
        <OutcomeConfiguration
          selectedOutcome={selectedOutcome}
          outcomes={outcomes}
          updateOutcomeConfiguration={updateOutcomeConfiguration}
          configureVariableDisplayOptions={configureVariableDisplayOptions}
          dataTypes={dataTypes}
          disabled={watchInterfaceType === InterfaceTypes.Chatbot || !selectedOutcome}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={4} style={clientUtils.getGridStyle('right', widthSize)}>
        <Grid container spacing={1} direction="row">
          <Grid item xs={12}>
            <Box className="hedading">
              <div className="title">Output Options</div>
              <div className="line"></div>
            </Box>
          </Grid>
          {selectedOptions &&
            selectedOutcome &&
            selectedOptions.length > 0 &&
            selectedOptions.map((option, index) => {
              return (
                <Grid item xs={6} sm={6} md={6} key={option.optionValue}>
                  <Chip
                    label={option.optionFriendlyName}
                    variant={'outlined'}
                    color="success"
                    size="small"
                    variant={
                      selectedOption && selectedOption.optionFriendlyName === option.optionFriendlyName ? 'filled' : 'outlined'
                    }
                    // avatar={<Avatar color="success">{option.name.charAt(0)}</Avatar>}
                    clickable
                    onClick={(e) => handleOptionClick(option)}
                    onDelete={(e) => handleDeleteOption(e, option)}
                  />
                </Grid>
              );
            })}
          <Grid item xs={6} sm={4} md={4}>
            {watchInterfaceType === InterfaceTypes.Form && (
              <Chip
                label="Add New Option"
                // variant="outlined"
                color="primary"
                size="small"
                clickable
                icon={<AddIcon />}
                onClick={(e) => addNewOption()}
                disabled={watchInterfaceType === InterfaceTypes.Chatbot || !selectedOutcome}
              />
            )}
          </Grid>
        </Grid>
        <OutcomeOptionConfiguration
          selectedOutcome={selectedOutcome}
          selectedOption={selectedOption}
          updateOptionConfiguration={updateOptionConfiguration}
          disabled={watchInterfaceType === InterfaceTypes.Chatbot || !selectedOption}
        />
      </Grid>
    </Grid>
  );
};

export default DefineModelOutcomes;
